import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import { InternalAxiosRequestConfig } from 'axios';

const getToken = async () => {
  try {
    const currentUserSession = await fetchAuthSession();
    return currentUserSession.tokens?.accessToken.toString();
  } catch (error) {
    await signOut({ global: true });
    throw error;
  }
};

const handleAccess = async (config: InternalAxiosRequestConfig) => {
  try {
    const accessToken = await getToken();

    if (accessToken) {
      config.headers['Authorization'] = accessToken;
    }

    return config;
  } catch (error) {
    return Promise.reject(error);
  }
};

export default handleAccess;
